module.exports = __webpack_public_path__ + "static/media/bots_12_gif.a2f6e7ae.gif";